import styled from 'styled-components';
import { CALENDAR_VIEW_TYPE } from 'features/appointment/services/constants';

type SelectDateRadioButtonGroupProps = {
    value?: CALENDAR_VIEW_TYPE;
    onChange?: (value: CALENDAR_VIEW_TYPE) => void;
};

const SelectDateRadioButtonGroup = ({ value, onChange }: SelectDateRadioButtonGroupProps) => {
    const options = [
        { label: 'Day', value: CALENDAR_VIEW_TYPE.DAY_VIEW },
        { label: 'Week', value: CALENDAR_VIEW_TYPE.WEEK_VIEW },
        { label: '2 Weeks', value: CALENDAR_VIEW_TYPE.TWO_WEEKS },
        { label: 'Monthly', value: CALENDAR_VIEW_TYPE.MONTH_VIEW },
    ];
    return (
        <Container>
            {options.map((option) => (
                <ButtonItem type='button' key={option.value} className={value === option.value ? 'selected' : ''} onClick={() => onChange?.(option.value)}>
                    {option.label}
                </ButtonItem>
            ))}
        </Container>
    );
};

export default SelectDateRadioButtonGroup;


const Container = styled.div`
    height: 54px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    background: #E5E6EB;
`;

const ButtonItem = styled.button`
    display: flex;
    min-width: 79px;
    padding: 8px 12px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    align-self: stretch;
    border-radius: 4px;

    color: #1D2129;
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    text-transform: capitalize;
    white-space: nowrap;
    transition: all 0.3s ease;
    &:hover:not(.selected) {
        background: #adadad;
    }
    &.selected {
        background: #232F3E;
        color: #fff;
    }
`;